import * as React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import StyledLink from '../common/styledLink';

const styles = theme => ({
    imageContainer: {
        [theme.breakpoints.only("md")]: {
            flex: "0 0 550px"
        },
        [theme.breakpoints.only("lg")]: {
            flex: "0 0 750px"
        },
        [theme.breakpoints.only("xl")]: {
            flex: "0 0 1000px",
        }
    },
    image: {
        width: "100%",
        height: "100%"
    },
    container: {
        display: "flex",
        margin: "1rem 0",
        border: "0px solid #aaa",
        padding: "3rem 2rem",
        //backgroundColor: pal.back,
        flexDirection: "column" as "column",

        [theme.breakpoints.up("md")]: {
            flexDirection: "row" as "row", //workaround for 'string' is not assignable to type 'FlexDirectionProperty' error
        }
    },
    header: {
        fontWeight: "bold" as "bold",
        margin: "0.3rem 0 1.5rem"
    },
    content: {
        position: "relative",
        flex: 1,
        padding: "2.5rem 2rem",
        order: 1,

        [theme.breakpoints.up("md")]: {
            padding: "3rem 2rem",
            order: 0,
        }
    },
    contentWithLink: {
        padding: "3rem 2rem 6rem",
    }
})


export class PageBlock extends React.Component<any, IPageBlockState> {
    static NAME: string = "PageBlock";

    constructor(props) {
        super(props);
        const block = props.page.blocks.filter((x: { id: string }) => x.id == props.id)[0];
        const ix = block && block.sortIndex && block.sortIndex.raw || "0";

        const theme = props.theme;

        var oddBackground = theme.palette.background.default;
        var evenBackground = theme.palette.background.default;

        if (props.oddBackground === "darkest")
            oddBackground = theme.palette.primary.darkest;
        else if (props.oddBackground === "dark")
            oddBackground = theme.palette.primary.dark;
        else if (props.oddBackground === "main")
            oddBackground = theme.palette.primary.main;
        else if (props.oddBackground === "light")
            oddBackground = theme.palette.primary.light;
        else if (props.oddBackground === "lightest")
            oddBackground = theme.palette.primary.lightest;

        if (props.evenBackground === "darkest")
            evenBackground = theme.palette.primary.darkest;
        else if (props.evenBackground === "dark")
            evenBackground = theme.palette.primary.dark;
        else if (props.evenBackground === "main")
            evenBackground = theme.palette.primary.main;
        else if (props.evenBackground === "light")
            evenBackground = theme.palette.primary.light;
        else if (props.evenBackground === "lightest")
            evenBackground = theme.palette.primary.lightest;

        this.state = {
            title: block && block.title && block.title.raw || '',
            content: block && block.content && block.content.rendered || '',
            image: block && block.image,
            sortIndex: parseInt(ix),
            oddBackground: oddBackground,
            evenBackground: evenBackground,
            titleColor: props.titleColor,
            link: props.link,
            linkText: props.linkText || "Find out more",
        };
    }

    render() {
        const s = this.state.sortIndex % 2 !== 1;
        const { classes } = this.props;


        const I = () => {
            if (!this.state.image) return (<></>);

            return (
                <div className={classes.imageContainer}>
                    <GatsbyImage image={this.state.image.childImageSharp.gatsbyImageData} alt={this.state.title} className={classes.image} />
                </div>
            );
        }

        const pal = {
            back: s ? this.state.evenBackground : this.state.oddBackground,
            fore: s ? this.state.oddBackground : this.state.evenBackground,
        }

        const getTitleColor = () => {
            if (this.state.titleColor)
                return this.state.titleColor;
            else
                return pal.fore;
        }

        return (
            <div className={classes.container} style={{ backgroundColor: pal.back, color: pal.fore }}>
                {s && <I />}
                <div className={`${classes.content} ${this.state.link ? classes.contentWithLink : ""}`}>
                    <h2 className={classes.header} style={{ color: getTitleColor() }}>{this.state.title}</h2>
                    {/* eslint-disable-next-line react/no-danger */}
                    <div style={{ color: pal.fore }} dangerouslySetInnerHTML={{ __html: this.state.content }} ></div>
                    {this.state.link && <Button href={this.state.link} variant="contained" style={{ backgroundColor: pal.fore, color: pal.back, textTransform: "none", position: "absolute", bottom: "3rem", left: "50%", transform: "translateX(-50%)" }}>{this.state.linkText}</Button>}
                </div>
                {!s && <I />}
            </div>
        );
    }
}

interface IPageBlockState {
    title: string;
    titleColor: string;
    content: string;
    image: any;
    sortIndex: number;
    oddBackground: string;
    evenBackground: string;
    link: string;
    linkText: string;
}

export default withStyles(styles, { withTheme: true })(PageBlock)
